(function(){
var cardUid=0;
// RT 2026-10-28 ("still loads way too slow"): supplier photos are the makers' full files, 1-3 MB PNGs (2000x2000)
// for a ~263 px box, so an open band sat white while ~15 MB came in. Cards show a 560 px WebP copy baked by
// ~/rt-img (bake.py, same key); a photo with no copy yet falls back to the original once.
var THUMB='https://rt-img.rtsaleslimited.workers.dev/t/v1/';
function thumbKey(s){var h1=0xdeadbeef,h2=0x41c6ce57,i,ch;for(i=0;i<s.length;i++){ch=s.charCodeAt(i);h1=Math.imul(h1^ch,2654435761);h2=Math.imul(h2^ch,1597334677);}
h1=Math.imul(h1^(h1>>>16),2246822507);h1^=Math.imul(h2^(h2>>>13),3266489909);h2=Math.imul(h2^(h2>>>16),2246822507);h2^=Math.imul(h1^(h1>>>13),3266489909);
var n=4294967296*(2097151&h2)+(h1>>>0),x=n.toString(16);return '00000000000000'.slice(x.length)+x;}
function thumbOf(url){return THUMB&&/^https:\/\//.test(url||'')?THUMB+thumbKey(url)+'.webp':url;}
window.RTRimThumb={key:thumbKey,of:thumbOf};
window.RTRimCards={create:function(CARD_TEMPLATE,config){
var {rgBits,rgChoose,rgShortTitle,rgSelRows,rgSpecRows,rgAxisText}=window.RTRimGrouping;
var CARD_SETTINGS=config.settings||{},wantByKey={};
var openQuote=config.openQuote;
function make(tag,text,cls){var e=document.createElement(tag);if(text!==undefined)e.textContent=text;if(cls)e.className=cls;return e;}
function compact(s){return String(s||'').toLowerCase().replace(/[^a-z0-9]/g,'');}
  function stampCard(li, it, items) {
    li.dataset.part = it && it.part ? String(it.part) : '';
    li.dataset.id = it && it.id ? String(it.id) : '';
    li.dataset.size = it && it.size ? String(it.size) : '';
    li.dataset.brand = it && it.brand ? String(it.brand) : '';
    li.dataset.kind = 'rim';
    li.dataset.bolt = it && it.bolt ? String(it.bolt) : '';
    if (it && typeof it.offset === 'number') li.dataset.offset = String(it.offset); else delete li.dataset.offset;
    // DRAFT 2026-10-08: the h3 now shows a short title, so the full supplier title and the
    // bore ride on the card for the sourcing extension (it matches on data-part today).
    var bits = rgBits(it);
    li.dataset.bore = bits.bore;
    li.dataset.title = it && it.title ? String(it.title) : '';
    li.dataset.shortTitle = rgShortTitle(it, true);
    li.dataset.parts = JSON.stringify((items || []).map(function (x) {
      return { part: x.part || '', size: x.size || '', offset: typeof x.offset === 'number' ? x.offset : null, bolt: x.bolt || '',
        bore: rgBits(x).bore, title: x.title ? String(x.title) : '' };
    }));
  }
  function pill(text, on, pick, name, value, disabled) {
    var input=make('input'); input.type='radio'; input.name=name; input.id=name+'-'+value;
    input.value=value; input.checked=on; input.disabled=disabled;
    input.setAttribute('aria-disabled',String(disabled));
    var label=make('label',text,'rt-mi__pill');label.htmlFor=input.id;
    input.addEventListener('change',function(){
      if(!input.checked||input.disabled)return;
      pick();
      var next=document.getElementById(input.id);if(next)next.focus();
    });
    var pair=document.createDocumentFragment();pair.append(input,label);return pair;
  }
  function paintOpts(box, choice, pick, uid) {
    box.textContent='';
    choice.axes.forEach(function(ax){
      if(ax.all.length<2)return;
      var wrap=make('fieldset',undefined,'rt-mi__optgrp product-form__input product-form__input--pill');
      wrap.dataset.axis=ax.key;
      wrap.appendChild(make('legend',ax.label,'rt-mi__optlab form__label caption'));
      var row=make('div',undefined,'rt-mi__optrow');
      ax.all.forEach(function(v,index){
        row.appendChild(pill(rgAxisText(ax.key,v),v===ax.pick,function(){
          var want={bolt:choice.bolt,dia:choice.dia,wid:choice.wid,off:choice.off,bore:choice.bore,part:choice.part};
          want[ax.key]=v;pick(want);
        },uid+'-'+ax.key,String(index),ax.here.indexOf(v)===-1));
      });
      wrap.appendChild(row);box.appendChild(wrap);
    });
    box.hidden=!box.children.length;
  }
  function productLink(it) {
    var o = it && it.retail_offer;
    return [o && o.url, it && it.product_url].find(function (url) {
      return /^\/products\/[a-z0-9][a-z0-9-]*(?:\?variant=\d+)?$/.test(url || '');
    }) || '';
  }
  function cardOffer(it) {
    var o = it && it.retail_offer;
    return o && o.currency === 'CAD' && (o.unit === 'rim' || o.unit === 'set') && isFinite(o.price) && o.price > 0 ? o : null;
  }
  function syncOffer(li, it) {
    var o = cardOffer(it), url = productLink(it);
    var price = li.querySelector('.price'), link = li.querySelector('[data-rt-mi-link]');
    price.hidden = !o;
    if (o) {
      var offers = li._rtItems.map(cardOffer).filter(function (offer) { return offer && offer.unit === o.unit; });
      var varies = !li._rtPricePicked && offers.some(function (offer) { return Number(offer.price) !== Number(o.price); });
      var amount = varies ? Math.min.apply(null, offers.map(function (offer) { return Number(offer.price); })) : Number(o.price);
      var formatted = CARD_TEMPLATE.dataset.money.replace('__RT_AMOUNT__', new Intl.NumberFormat('en-CA').format(Math.ceil(amount)));
      li.querySelector('[data-rt-mi-amount]').textContent = varies ? CARD_TEMPLATE.dataset.from.replace('__RT_PRICE__', formatted) : formatted;
      li.querySelector('.rt-price-basis').textContent = o.unit === 'set' ? 'set of 4' : 'per rim';
    }
    link.href = url || '#rt-mi-qh';
    if (url) { link.removeAttribute('aria-haspopup'); link.removeAttribute('aria-controls'); }
    else { link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-controls', config.quoteId); }
    var details = li.querySelector('.rt-mi__details'), act = details.querySelector('.rt-mi__act');
    var tag = url ? 'A' : 'BUTTON';
    if (!act || act.tagName !== tag) {
      var next = make(tag.toLowerCase(), '', 'rt-mi__act button button--secondary');
      if (!url) {
        next.type = 'button';
        next.addEventListener('click', function () { openQuote(li._rtItem, next); });
      }
      if (act) act.replaceWith(next); else details.appendChild(next);
      act = next;
    }
    if (url) act.href = url;
    act.textContent = url ? 'View & buy →' : 'Get a quote →';
    var stock=details.querySelector('.rt-mi__stock');
    if(!stock)stock=make('p',undefined,'rt-mi__stock caption');
    var supplier=it.supplier||it.supplier_name;
    stock.textContent=(typeof supplier==='string'&&supplier ? supplier+' · ' : '')+'Supplier catalogue · availability confirmed with quote';
    details.appendChild(stock);
  }
  function syncImage(li, it) {
    var inner = li.querySelector('.card__inner'), media = inner.querySelector('.media');
    var placeholder = li._rtPlaceholder || media.querySelector('.placeholder-svg'), img = media.querySelector('img');
    li._rtPlaceholder = placeholder;
    var url = /^https:\/\//.test(it && it.image_url || '') ? it.image_url : '';
    function ratio(value) {
      var percent = (100 / value) + '%';
      inner.style.setProperty('--ratio-percent', percent);
      li.querySelector('.card').style.setProperty('--ratio-percent', percent);
    }
    ratio(0.75);
    if (!url) { if (img) img.remove(); media.appendChild(placeholder); return; }
    if (!img) {
      img = make('img', undefined, 'motion-reduce'); img.loading = 'lazy'; img.decoding = 'async';
      img.width = 533; img.height = 533; img.sizes = CARD_TEMPLATE.dataset.sizes;
      img.addEventListener('load', function () {
        placeholder.remove();
        img.width = img.naturalWidth; img.height = img.naturalHeight;
        ratio(0.75);
      });
      img.addEventListener('error', function () {
        // No small copy yet (a photo newer than the last bake): the supplier's own file, once.
        if (img._rtOrig && img.getAttribute('src') !== img._rtOrig) { img.src = img._rtOrig; return; }
        img.remove(); media.appendChild(placeholder); ratio(0.75);
      });
      media.appendChild(img);
    }
    img.alt = (it && (it.image_alt || it.title)) || '';
    // The grey placeholder stays under the photo until it has loaded (the load handler removes it).
    if (img._rtFor !== url) { img._rtFor = url; img._rtOrig = url; img.src = thumbOf(url); }
    
  }
  function renderCard(li, items) {
    var choice = rgChoose(items, li._rtWant || null);
    var it = choice.item;
    li._rtItems = items;
    li._rtItem = it;
    li._rtWant = { bolt: choice.bolt, dia: choice.dia, wid: choice.wid, off: choice.off, bore: choice.bore, part: choice.part };
    if (li.dataset.gkey) wantByKey[li.dataset.gkey] = li._rtWant; if(config.onPick) config.onPick(it);
    stampCard(li, it, items);
    var title = li.querySelector('[data-rt-mi-link]');
    // v2: a grouped card (2+ parts) titles the wheel (no size) and shows the picked part in a
    // "Selected" box under the selectors. A single part keeps title + Part # + spec rows.
    var grouped = (items || []).length > 1;
    var brandLine = !!li.querySelector('[data-rt-mi-vendor]');
    if (brandLine) li.querySelector('[data-rt-mi-vendor]').textContent = it.brand && it.brand !== 'Other' ? it.brand : '';
    var short = rgShortTitle(it, !grouped) || it.title || '';
    if (!brandLine && it.brand && it.brand !== 'Other' && compact(short).indexOf(compact(it.brand)) === -1) short = it.brand + ' ' + short;
    title.textContent = short;
    // Staff quote line (extension catqHeading reads every text node of the h3): a hidden tail keeps
    // size (grouped) / bolt / offset / bore of the picked part on the quote line. Screen readers skip it.
    var bitsNow = rgBits(it);
    var tailParts = rgSpecRows(it).map(function (r) { return r[0] === 'Centre bore' ? 'CB ' + r[1] : r[0] === 'Offset' ? 'Offset ' + r[1] : r[1]; });
    if (grouped && bitsNow.dia != null && bitsNow.wid != null) tailParts.unshift(bitsNow.dia + 'x' + bitsNow.wid);
    var tailText = tailParts.join(' \u00b7 ');
    if (tailText) {
      var tail = make('span', ' \u00b7 ' + tailText, 'rt-mi__sr rt-mi__ttail visually-hidden');
      tail.setAttribute('aria-hidden', 'true');
      title.appendChild(tail);
    }
    li.querySelector('[data-rt-mi-staff-heading]').textContent = title.textContent;
    var optsEl=li.querySelector('.rt-mi__opts'),box=li.querySelector('.rt-mi__specbox');
    if(!box){box=make('div',undefined,'rt-mi__specbox rt-mi__sel');optsEl.insertAdjacentElement('afterend',box);}
    box.textContent='';
    var rows=rgSelRows(it,items);
    var finishReader = window.RT_RIM_FINISHES;
    var finish = finishReader && finishReader.label ? finishReader.label(it) : '';
    if (finish) rows.splice(1, 0, ['Finish', finish, items.every(function (item) { return finishReader.label(item) === finish; })]);
    box.appendChild(make('p','Selected','rt-mi__sellab caption-with-letter-spacing'));
    var specEl = make('dl', undefined, 'rt-mi__specs caption');
    rows.forEach(function (r) {
      var row = make('div', undefined, 'rt-mi__spec' + (grouped && r[2] ? ' rt-mi__spec--same' : ''));
      row.appendChild(make('dt', r[0]));
      row.appendChild(make('dd', r[1]));
      specEl.appendChild(row);
    });
    box.appendChild(specEl);
    box.hidden = !rows.length;
    syncImage(li, it);
    paintOpts(li.querySelector('.rt-mi__opts'), choice, function (want) {
      li._rtWant = want;
      li._rtPricePicked = true;
      renderCard(li, li._rtItems);
      li.dispatchEvent(new CustomEvent('rt-mi-pick', { bubbles: true }));
    }, li._rtUid);
    syncOffer(li, it);
  }
  function buildCard(items, key, existing) {
    var li = CARD_TEMPLATE.content.firstElementChild.cloneNode(true);
    if(existing){existing.className=li.className;existing.replaceChildren(...li.childNodes);li=existing;}
    li._rtUid='rt-rim-'+(++cardUid);
    if (key) li.dataset.gkey = key;
    if (key && wantByKey[key]) li._rtWant = wantByKey[key];
    var shape = CARD_SETTINGS.imageShape;
    if (shape && shape !== 'default') {
      li.querySelector('.card').classList.add('card--shape');
      li.querySelector('.card__media').classList.add('shape--' + shape, 'color-' + CARD_TEMPLATE.dataset.scheme, 'gradient');
    }
    if (CARD_SETTINGS.showVendor === 'true') {
      var info = li.querySelector('.card-information');
      info.prepend(make('div', '', 'caption-with-letter-spacing light'));
      info.firstElementChild.setAttribute('data-rt-mi-vendor', '');
      info.prepend(make('span', 'Vendor', 'visually-hidden'));
    }
    li.querySelector('[data-rt-mi-link]').addEventListener('click', function (e) {
      if (productLink(li._rtItem)) return;
      e.preventDefault(); openQuote(li._rtItem, e.currentTarget);
    });
    renderCard(li, items);
    return li;
  }

return {buildCard,renderCard};}};
})();
